// history.js
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

export default createBrowserHistory({
  basename: process.env.NODE_ENV !== 'development' ? process.env.PUBLIC_URL : undefined,
});
